export enum StatusTypesIDs {
  Existing = 1,
  UnderConstruction = 2,
  ProposedLongTerm = 3,
  ProposedShortTerm = 4,
  UnderRenovation = 5,
  Demolished = 7,
  Converted = 8,
}

export enum StatusTypes {
  Existing = 'Existing',
  UnderConstruction = 'Under Construction',
  UnderRenovation = 'Under Renovation',
  ProposedShortTerm = 'Proposed Short-Term',
  ProposedLongTerm = 'Proposed Long-Term',
  Demolished = 'Demolished',
}
